module.exports = __webpack_public_path__ + "img/sliders.87958b98.svg";